import CreatePostInput from './create-post-input'

export type { CreatePostInputProps } from './create-post-input'

export default CreatePostInput
